import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import groundcover from '@groundcover/browser';
import { GreenroomState } from '../stores/types/types';
import { telemetryEnabled } from '../utils/telemetry';

/*
	Attaches the logged-in user's identity to Groundcover RUM sessions, logs,
	and exceptions. The id matches Amplitude's setUserId (`gr_user_<id>`) so
	sessions can be correlated across both tools.

	The SDK has no reset/un-identify API; on logout the identity persists
	until the page reloads, which the logout flow already forces.
*/
const useGroundcoverIdentify = () => {
	const user = useSelector((state: GreenroomState) => state.SessionReducer.user);
	const host = useSelector((state: GreenroomState) => state.SessionReducer.host);
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting);

	useEffect(() => {
		if (!telemetryEnabled || !user?.gr_user) return;

		groundcover.identifyUser({
			id: `gr_user_${user.gr_user}`,
			email: user.email,
			role: host ? 'producer' : 'presenter',
			properties: {
				active_channel: user.active_channel ?? null,
				meeting: meeting?.meeting ?? null,
				meeting_id: meeting?.meeting_id ?? null,
			},
		});
	}, [user?.gr_user, host, meeting?.meeting]);
};

export default useGroundcoverIdentify;
